import { linea, lineaSepolia, defineChain } from 'thirdweb/chains'

/* Custom chains */
export const codex = defineChain(81224) // https://thirdweb.com/codex
export const codexTestnet = defineChain(812242) // https://thirdweb.com/codex-testnet

/**
 * List of supported chains.
 */
export const supportedChains = [codex, codexTestnet, linea, lineaSepolia]

/**
 * Map of supported chain IDs to Chain objects.
 */
export const CHAIN_IDS_TO_CHAINS = {
  [59141]: lineaSepolia,

  [59144]: linea,

  [81224]: codex,

  [812242]: codexTestnet,
}

export type SupportedChainId = keyof typeof CHAIN_IDS_TO_CHAINS

export const SUPPORTED_CHAIN_IDS: number[] = Object.keys(
  CHAIN_IDS_TO_CHAINS,
).map((key) => Number(key))
